import script from "./CallParticipantsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallParticipantsPanel.vue?vue&type=script&setup=true&lang=ts"

import "./CallParticipantsPanel.vue?vue&type=style&index=0&id=db524de8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db524de8"]])

export default __exports__